mutation completeOnboardingStepBilling {
  completeOnboardingStepBilling {
    stepName
    status
    errorCode
    message
  }
}
